// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  treeId: __t.u64().primaryKey().name("tree_id"),
  regionId: __t.u64().name("region_id"),
  archetypeId: __t.string().name("archetype_id"),
  archetypeSeed: __t.u64().name("archetype_seed"),
  generatorVersion: __t.string().name("generator_version"),
  positionX: __t.f64().name("position_x"),
  positionY: __t.f64().name("position_y"),
  positionZ: __t.f64().name("position_z"),
  rotationY: __t.f64().name("rotation_y"),
  deployedAt: __t.timestamp().name("deployed_at"),
  rootSegmentId: __t.u64().name("root_segment_id"),
});
